import { Descriptions, Table } from 'antd'
import { formatCurrency, formatNumber } from '../../utils/string-utils'
import {
  dataTypeColumns,
  dataTypeDayColumns,
  getOriginalRevenueLabel,
  packageDayColumns
} from '../../utils/dashboard-utils'

export const renderTableDescription = (data: any, network: string) => {
    return (
        <Descriptions title="Tổng kết" items={[
            {
                label: 'Đã bán trong ngày',
                children: formatNumber(data?.reduce((sum: any, value: any) => sum += Number(value.totalAmount_current || 0), 0)),
            },
            {
                label: 'Doanh thu trong ngày',
                children: formatCurrency(data?.reduce((sum: any, value: any) => sum += Number(value.count_current || 0), 0)),
            },
            // Hidden is this version
            // {
            //     label: 'NET trong ngày',
            //     children: formatCurrency(data?.reduce((sum: any, value: any) => sum += Number(value.totalProfit_current || 0), 0)),
            // },
            {
                label: 'Ngày trong tháng trước',
                children: formatNumber(data?.reduce((sum: any, value: any) => sum += Number(value.totalAmount_previous || 0), 0)),
            },
            {
                label: 'Ngày trong tháng trước',
                children: formatCurrency(data?.reduce((sum: any, value: any) => sum += Number(value.count_previous || 0), 0)),
            },
            {
                label: 'Ngày trong tháng trước',
                children: formatCurrency(data?.reduce((sum: any, value: any) => sum += Number(value.totalProfit_previous || 0), 0)),
            },
            {
                label: 'Số lượng chênh lệch',
                children: formatNumber(data?.reduce((sum: any, value: any) => sum += Number(value.totalAmount_current - value.totalAmount_previous || 0), 0)),
            },
            {
                label: 'Doanh thu chênh lệch',
                children: formatCurrency(data?.reduce((sum: any, value: any) => sum += Number(value.count_current - value.count_previous || 0), 0)),
            },
            // Hidden is this version
            // {
            //     label: 'NET chênh lệch',
            //     children: formatCurrency(data?.reduce((sum: any, value: any) => sum += Number(value.totalProfit_current - value.totalProfit_previous || 0), 0)),
            // },
            {
                label: 'Số nhóm',
                children: formatNumber(data.length),
            },
            {
                label: 'Số gói',
                children: formatNumber(data?.reduce((sum: any, value: any) => sum += Number(value.detail?.length || 0), 0)),
            },
            ...(network !== 'TDM_ZYNET' ? getOriginalRevenueLabel(data) : []),
        ]} />
    )
}

export default function TableDetailPackageByDay({ day, data, network }: any) {
    return (
        <Table
            rowKey={(_, index: any) => index}
            style={{ overflow: 'auto' }}
            columns={day > 0 ? dataTypeDayColumns : dataTypeColumns}
            dataSource={data}
            expandable={{
                expandedRowRender: (record: any) => (
                    <div style={{ marginBottom: 40, padding: 10, border: '1px solid grey', borderRadius: 10 }}>
                        <Table
                            size='small'
                            rowKey={(_, index: any) => index}
                            style={{ overflow: 'auto' }}
                            columns={packageDayColumns}
                            dataSource={record.detail}
                            pagination={false}
                        />
                    </div>
                ),
            }}
            pagination={false}
            footer={() => renderTableDescription(data, network)}
        />
    )
}
